import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Profile } from '@core/models';
import { UserService } from '../user.service';
import { RequestsUtilityService } from '../utilities';

@Injectable({ providedIn: 'root' })
export class AddUserService {
  private http = inject(HttpClient);
  private userService = inject(UserService);
  private requestsUtilityService = inject(RequestsUtilityService);

  private options = this.requestsUtilityService.bearerToken(
    this.userService.user.token,
  );

  private apiUrl = environment.restApiUrl;

  public addUser(data: any): Observable<Profile> {
    return this.http.post<Profile>(
      `${this.apiUrl}auth/create-user-by-type`,
      data,
      {
        headers: this.options,
      },
    );
  }
}
